import React from 'react';
import { Grid } from '@mui/material';

import { SimpleTextField, SwitchField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function DocumentsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ lg: 9, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="fold_title"
					label={t('DETAILS_DOCUMENTS_FOLDERS_FIELD_TITLE')}
					value={props.model.fold_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ lg: 3, xs: 12 }}>
				{/* ORDER */}
				<SimpleTextField
					name="fold_order"
					label={t('DETAILS_DOCUMENTS_FOLDERS_FIELD_ORDER')}
					type="number"
					value={props.model.fold_order}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ lg: 3, md: 6, xs: 12 }}>
				{/* ACTIVE */}
				<SwitchField
					name="fold_active"
					label={t('DETAILS_DOCUMENTS_FOLDERS_FIELD_ACTIVE')}
					value={props.model.fold_active}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ lg: 3, md: 6, xs: 12 }}>
				{/* PERSONAL */}
				<SwitchField
					name="fold_personal"
					label={t('DETAILS_DOCUMENTS_FOLDERS_FIELD_PERSONAL')}
					value={props.model.fold_personal}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
